/**
 * @deprecated use the one in repoV2/features/Common/utils/numbers.ts
 */
export const roundOff = (value: number, places: number) =>
    (Math.round(value * 100) / 100).toFixed(places);
